import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React, {useEffect, useState} from 'react'
import 'normalize.css'
import Menu from './containers/menu'
import './App.scss'
import Board from './containers/board'
import Loader from './components/loader'
import {resize} from './constants/events'
import bem from './helpers/bem';

const App = () => {
  const block = 'App';
  const [cardsMenu, setCardsMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const updateIsMobile = () => {
    return setIsMobile(window.innerWidth <= 834)
  };
  const [cursorPointer, setCursorPointer] = useState(false);
  useEffect(() => {
    document.getElementsByTagName("body")[0].style.cursor = cursorPointer ? 'pointer' : 'default';
  }, [cursorPointer]);

  useEffect(() => {
    const prevent = (e) => {
      const notificationBlock = document.getElementsByClassName('board__poc-notification')[0];
      const chooseBlock = document.getElementsByClassName('menu__choose-main-block')[0];
      const isChooseTouched = chooseBlock && chooseBlock.contains(e.target);
      const isNotificationTouched = notificationBlock && notificationBlock.contains(e.target);
      if (!isNotificationTouched && !isChooseTouched) {
        e.preventDefault();
      }
    };
    const appHeight = document.getElementsByClassName('App')[0].offsetHeight;
    if (appHeight <= document.body.offsetHeight) {
      document.body.addEventListener('touchmove', prevent, { passive: false });
      document.ontouchmove = prevent;
    }
    updateIsMobile();
    window.addEventListener(resize, updateIsMobile);
    return () => window.removeEventListener(resize, updateIsMobile);
  }, []);
  return (
    <Loader start={Date.now()}>
      <div className={bem({block, mods: {'clickable': !!cursorPointer}})}>
        <Menu
          setCardsMenu={setCardsMenu}
          cardsMenu={cardsMenu}
          isMobile={isMobile}
        />
        <Board
          setCardsMenu={setCardsMenu}
          isMobile={isMobile}
          setCursorPointer={setCursorPointer}
        />
      </div>
    </Loader>
  );
};

export default App;
